var CheckHelpers = /** @class */ (function () {
    function CheckHelpers() {
    }
    CheckHelpers.prototype.exist = function (keys, e) {
        var fails = keys.find(function (k) {
            return e.keyCode === k;
        });
        return !!fails;
    };
    return CheckHelpers;
}());
export { CheckHelpers };
